// =============================================================================
//  apiShops.js — client for the account's boutiques (User.boutiques)
//  (server_elakay/elakay_routes/shops.js). The server decides everything
//  (role, quota, price, payment, ownership); this file only transports.
//  NB: getMyShops in auth/stripe.js is a different thing (Page Builder shop
//  PAGES / templates) -- these are the account's business shops.
// =============================================================================
import { elakay_API } from "../../config";
import { isAuthenticated } from "../auth";

const getToken = () => isAuthenticated()?.token || "";

async function request(path, { method = "GET", body, auth = true } = {}) {
  const headers = { Accept: "application/json" };
  if (auth) headers.Authorization = `Bearer ${getToken()}`;
  const init = { method, headers };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
    init.body = JSON.stringify(body);
  }
  const response = await fetch(`${elakay_API}${path}`, init);
  let data = {};
  try { data = await response.json(); } catch { data = {}; }
  if (!response.ok || data.success === false) {
    const error = new Error(data.error || `Error ${response.status}`);
    error.status = response.status;
    error.code = data.code;
    error.details = data.details;
    throw error;
  }
  return data;
}

export const getAccountShops = () => request("/shops/mine");
export const createAccountShop = (payload) => request("/shops", { method: "POST", body: payload });
export const confirmAccountShopPayment = (shopId, paymentIntentId) => request(`/shops/${encodeURIComponent(shopId)}/confirm-payment`, { method: "POST", body: { paymentIntentId } });
export const cancelAccountShop = (shopId, paymentIntentId) => request(`/shops/${encodeURIComponent(shopId)}/cancel`, { method: "POST", body: { paymentIntentId } });
export const setActiveAccountShop = (type, shopId) => request("/shops/active", { method: "PATCH", body: { type, shopId } });
export const updateAccountShop = (shopId, payload) => request(`/shops/${encodeURIComponent(shopId)}`, { method: "PATCH", body: payload });
export const getPublicShop = (shopId) => request(`/shops/public/${encodeURIComponent(shopId)}`, { auth: false });

// Animation Settings -> General -> Shop Management (Family).
export const getShopManagementSettings = () => request("/shop-management/settings");
export const saveShopManagementSettings = (payload) => request("/shop-management/settings", { method: "PUT", body: payload });

export const getShopDeletionSummary = (id) => request(`/shops/${encodeURIComponent(id)}/deletion-summary`);
export const deleteAccountShop = (id, destinationShopId) => request(`/shops/${encodeURIComponent(id)}`, { method: 'DELETE', body: { destinationShopId } });
export const transferShopProducts = (id, destinationShopId) => request(`/shops/${encodeURIComponent(id)}/transfer-products`, { method: 'POST', body: { destinationShopId } });

export const setShopProductPrice = (shopId, productId, price) => request(`/shops/${encodeURIComponent(shopId)}/products/${encodeURIComponent(productId)}/price`, { method: 'PUT', body: { price } });

export const getShopFollowStatus = (id) => request(`/shops/${encodeURIComponent(id)}/follow-status`);

// Seller product display (Shop Product Grid / Infinite Scroll) of one owned boutique.
export const getShopProductDisplay = (shopId) => request(`/shops/${encodeURIComponent(shopId)}/product-display`);
export const saveShopProductDisplay = (shopId, productDisplay) => request(`/shops/${encodeURIComponent(shopId)}/product-display`, { method: 'PUT', body: { productDisplay } });
